function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ef9534;}.a,.b,.c,.d,.e,.f,.g,.h,.i,.j,.k,.l{fill-rule:evenodd;}.b{fill:#d66f00;}.c{fill:#733010;}.d{fill:#470404;}.e{fill:#b05848;}.f{fill:#f7ac51;}.g{fill:#fac1b6;}.h{fill:#f7fffd;}.i{fill:#f7dd40;}.j{fill:#41ffe8;}.k{fill:#fff;}.l{fill:#fa285d;}.m{fill:#00baf2;stroke:#231f20;stroke-miterlimit:10;stroke-width:12px;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M281.51,0C437,0,563,126,563,281.48S437,563,281.51,563,0,437,0,281.48,126,0,281.51,0Zm0,184.65a96.85,96.85,0,1,1-96.85,96.85h0A96.87,96.87,0,0,1,281.51,184.65Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M26,327.43c.65-18.29,2.76-36.93,4.63-55.13,3.1-27.9,7-54.47,9.42-82.62,4-45.75,28.85-64,64.68-87.2,27.58-15.66,39.45-15.25,67.65-36.63,50.62-38.34,60.15-40,123.69-36.36,24.7,2.09,40.37,8.1,62.86,17.32,21.06,8.64,17.5-5.51,39.67,3.36,8.58,3.43,16.61,6.13,25.25,9.24C434.67,63.3,437.32,67.89,444.7,76c9.67,10.18,16.18,16.94,24.78,28.48,6,8.09,13.26,14.32,20.56,21.24,10.42,9.92,14.14,18.26,19.69,31.3A268.51,268.51,0,0,1,523,196.37c3,12.92,4.8,26.86,8.06,39.33,2,7.47,3.94,9.27,8.47,15.33,5.93,9.1,2.48,18.91,2.06,29.62s-2,25.34-1.18,35.46c1.11,13,.53,18.84-2.65,31.48a177.45,177.45,0,0,0-4.62,21.75c-1.54,10.47-7.08,13.4-12.31,22.8-1,1.9-2,3.84-3,5.78-5.15,10.84-9.76,21.48-14.63,32.39-5.17,11.61-11.28,14.6-18.56,24.35-4.87,6.51-12.57,13.28-18.25,19.87-5.4,6.27-11,12.37-16.52,18.51-26.33,29.22-56.63,46.51-95.55,52.76-41.09,4.55-68.15-13.15-109.9-10.32-52,3.77-67.66,11.42-108.45-26.55-32.64-30.39-62.58-60.09-89.19-96.21C27.16,386,25.6,359.58,26,327.43Zm174.9,40.92c-8.17-8.47-22.16-23.94-25.8-34.83-2.08-6.23-1.14-6.93-4.52-13-6.75-12.12-8.15-20.34-6.15-33.93,1.71-11-.17-21.31,2.12-33.45,3-15.91,10.49-24.79,21.29-36.36,6.17-6.62,14.64-11.26,22.54-15.53,18-9.28,58.95-29.73,78-30.48,18.11-.52,31.56,5,48.86,9.41,11.49,2.91,18.07,4.83,28,11.6,13.49,10.57,15,22.52,22.33,36.89,10.12,19.79,12.46,20.45,13.22,44.48,1.48,46.8-20.9,80.81-55.89,109.73-11.32,9.24-23.9,11.68-37.9,14.51-20.92,4.25-31.52-.14-51.43-5.4-18.82-4.95-39.36-11.27-54.72-23.64Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M76.7,435.43c-43-40.92-55.2-59.15-54.2-121.1.66-18.29,2.75-36.93,4.63-55.13,3.11-27.91,7-54.48,9.42-82.62,4-45.75,28.86-64,64.68-87.19,27.57-15.67,39.45-15.26,67.66-36.63C219.5,14.41,229,12.78,292.56,16.4c39.51,2.35,89.17,29.24,124.33,47.31A178.48,178.48,0,0,1,440.37,78c51,41.48,82,101.27,90.85,166.21,4.19,41.54-18.21,104.73-32.16,145-23.5,63.53-73.89,140.24-150,138.9-48.81-1.22-91.37-8.51-141.46-8.17-53.73.36-58.36-5.52-94-45.78C101.64,460.76,89.47,448,76.7,435.43Zm120.71-80.17C184.27,343,158,300.52,153.62,282.93c-9.21-37,11-67,39.77-88.07,23-15.81,62.82-39.8,91.31-38.25,23.9,1.31,57.84,7.71,77,22.09,20,15.4,26.41,29.45,32.41,55.17,12.3,58.84-10.21,101.74-55.93,138.64-27.94,22.54-54,14.84-86.07,6.38-18.82-4.95-39.36-11.26-54.71-23.63Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M178.61,331.15c-11.18-16.9-22.29-37.33-25-48.22-9.2-37,11-67,39.77-88.06,23-15.82,62.82-39.81,91.31-38.26,23.9,1.31,57.85,7.72,77,22.09a93.27,93.27,0,0,1,13.54,12.51c-4.88-8.84-11.47-16.42-21.7-24.16-19.1-14.47-41.47-28.94-65.36-30.25-15.78-.85-45.81,2.32-69.67,13.25-19.24,8.81-36.58,31.76-46.7,39-29,20.68-35.56,45.27-26.36,82.24,3.37,13.57,19.79,42,33.15,59.88Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M76.7,435.43c-17.84-17-30.37-30.06-38.87-44,7.8,9.92,17.89,20.11,30.71,32.32,12.78,12.59,24.94,25.32,36.83,38.76,7.39,8.37,31.27,37,41.53,37.69,4.12.21,6.12-1,10.74-.46,15.28,1.68,31.24,4.44,43.57,2.8,5.21-.7,32.26,3,40.63,3.67,7.08.4,13.12-.06,20.22,1.42,18.46,3.89,74.2,3.8,92.39.49,3.67-.66,26.28-6.74,29.06-8.14C451.08,463.89,427,490.52,457,416.2c5.29-13.09,19.82-26,24.58-39.23,14.4-40.1,46.36-103,41.48-144.41-4.72-40-19.28-78-41-111,26.43,35.56,43.06,77.86,49.15,122.62,4.19,41.54-18.21,104.73-32.16,145-19.8,53.13-57.64,115.06-114.45,133.59-4.28,1.38-9.71,2.47-14.18,3.46-14.22,3-25.58,1.44-39.76,1.1a189.66,189.66,0,0,1-21.3-1.69c-5.13-.66-10-.51-15.13-1.3a48.81,48.81,0,0,0-11.88-.86c-7.43.18-15-1.06-22.49-1.57-5.54-.38-10.73-1.22-16.36-1.36-7.32-.12-14.21-.5-21.49-.8l-2.84-.08c-5.32-.11-8.81-.52-14.24,0-7.13.57-21.85.11-28.72-1.39-7.26-1.53-10.94-1.09-17.38-5.4a43.18,43.18,0,0,0-8.5-4.75c-4.45-1.75-6.11-2.13-10-5.3a87.3,87.3,0,0,1-6.63-6.42c-3.08-3.17-6-6.46-9-9.74-3.76-4.16-7.45-8.35-11.16-12.54C101.64,460.76,89.48,448,76.7,435.43Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M69,275.7c5.46-20.59,20-51.55,36-17.21,20.27,44.74,15.15,69.53,45.37,110.8,12,16.38,36.53,45.7,10.52,62.46-27,17.38-67.49-28.09-80.78-49.27-23.19-37-21.39-66-11.12-106.78Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M247.61,555.92c-6.46-.75-27.35-1.25-31.56-3.87-4.53-2.82.12-7.62,3.15-9.22,15.29-7.25,46.1-5.18,62.95-2.77,7.34,1.05,26.49,3,29.49,10.76,3.4,8.77-19.89,10.39-24.73,10.57-13.45.49-26-3.81-39.3-5.47Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M421,381.73c-7.38-21,12.49-24.31,17.16-51,10.46-59.78-3.08-59-10.54-109.68-6.82-46.3,23.78-59.42,48.3-18,17,28.75,31.36,72.41,26,105.47-5.29,32.6-22.83,70.31-56.17,81.59l-5.47.46c-9.17-.12-13-2.95-19.27-8.88Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M217.51,57.89C247.87,52.75,289.9,47,319,58c22.9,8.58,48.82,24.6,67.92,39.9C400.42,109,435,134,432.65,154.07c-2.34,20.44-34.28,33.8-47.48,16.08C378.78,161.57,335.93,129,325,123c-36.18-18.48-57.87-18.67-96.77-8.79-37.87,9.88-83,20.08-105.07,55.73-8.83,14.26-10.07,22.44-16.29,36.79-9.76,22.51-42.53,10.05-31.21-18.84,10.45-26.67,18.56-49,38.67-70.25l5.35-5.65c28.07-29,57.73-46.73,97.83-54.06Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M398.49,403.32c45.94,11,4.39,57.89-21,71.58-53.12,24.56-155.38,35.93-194.94-16.69-19.7-26.21-2-33.4,24.69-25.61,66.57,19.44,81.28,12.92,141.65-19.92,18-9.9,29-13.24,49.58-9.36Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M79.05,432.59c-43-40.94-55.2-59.16-54.21-121.11.66-18.29,2.76-36.93,4.64-55.13,3.1-27.9,7-54.48,9.42-82.63,4-45.74,28.85-64,64.68-87.19C131.16,70.87,143,71.28,171.24,49.9c50.61-38.34,60.14-40,123.67-36.36,39.5,2.37,89.18,29.24,124.33,47.31,8.81,4.53,15.65,13.53,23.64,19.35,1.49,1.09,2.87,2.37,4.28,3.57-3.21-1.9-6.55-3.76-10.27-5.66-9-4.63-24.94-9.14-36.64-11.66-33.94-7.32-58.51-39-87.85-40.67-32.2-1.85-24.37-8.09-48.09-5.37-12.57,1.43-15,14.37-40.92,29.76-21.09,12.52-33.21,2.57-81.28,24.64-8.13,3.72-25,27.62-33.29,32.69-36.37,22.29-48.5,32.72-52.44,78.5C54,214.09,39.77,215.89,35.61,264.8,34,283,53.79,310.09,53.41,328.38c-1.27,61.94.32,75.34,43.12,116.44,12.94,12.42,24.08,12.79,36,26.22,48.51,54.78,2.18,21.52-16.62.3-11.89-13.42-24-26.17-36.83-38.75ZM400.72,255.91c4.59,22.36-1.19,29.22-9.48,49.11-2.38,5.67-5.37,12.87-8.44,18.15-8.87,14-12.38,17.62-24.07,28.81-7.3,7-14.29,14-21.72,21-4.59,4.32-11.31,11.24-16.65,14.3-8.9,4.38-20.58-.92-30.27-1.54-13.55-.57-18.29.18-32.14-3-6.28-1.45-21.45-3.5-26-5.82-10.31-5.29-15.31-10.26-2.53,1.39,6.09,5.56,10.28,6.21,18.08,8.65,11.06,3.45,14.21,5.47,27.07,6.67l1.93.18c12.36,1.05,13.46.48,25.58,5.12,19.85,7.36,28.09,3.39,44.19-8.88s17.09-26,40.44-36.82c19-8.84,32.71-4.17,28.15-31.62-3.53-19.57,0-17,5.43-34.6,5.71-20-2.37-31-7.82-49.75-4.51-14.6-14.9-31.34-28.17-39.34-10.59-6.39-5.43-3.94-1,4,3.42,6.16,4.6,14.88,7.86,22.23,5,11.32,6.29,13.9,8.57,26.42.31,1.78.66,3.57,1,5.34Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "g",
  d: "M340.77,107.21c48.22,10,31.48-6.48-3.25-16.15C256.19,69,185.73,68.55,124.16,134.74c-12.55,13.49-40.46,47.94-38.11,67.64,1.43,12,19.11-16.28,22.23-20.12C177.74,96.78,208.9,82.07,318.84,102.85,326.17,104.24,333.46,105.71,340.77,107.21Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "g",
  d: "M252,459.53c-5.23-.62-64.26-10.44-46.81,7.69,30.46,26.12,116.73,13,150.48-5.28,7.8-4.23,38.19-26.93,33.56-34.92-49,2.45-39.86,38.62-110.94,34.8-8.85-.48-17.48-1.34-26.29-2.29Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "g",
  d: "M476.43,326.41c11.44-40.73,7.64-90.81-21.71-123.41-22.36-24.84,12.12,68,12.21,68.28,9.6,36.66-34.88,91.22-21.4,99.05,8.54,4.94,28.44-36.58,30.9-43.92Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M6.61,293.13c-4.1-16-2.51-46.51.65-62.83,1-5,9.76-40.5,19.16-29.58,9.77,11.35-3.05,51.63-5,66.53-1,7.42-1.18,29.29-5.62,33.52s-8.22-4.33-9.2-7.64Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M393.08,285.35c-.64,8.06-2.78,20-8.28,26-4.16,3-4-4-4-6.77-.12-21.52,4.68-24.47-2.14-47.85-7.84-24.14-14.92-32.3-31.55-50.58C324.23,181.05,358.2,185.47,373,208c7.82,11.94,16.31,30,19.18,44,2.09,11.18,1.78,22,1,33.24Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M140.75,65.24c-6.49,3.66-33.12,16.81-39.48,15.26-6.07-1.48-1.19-8.53,1.1-11,7.7-8.14,18.86-13.53,28.11-20.18,18.17-13,34.05-23,55.94-28.61,15.62-4,21.92,3.58,5,13.78-9.75,5.84-17.86,10.1-27.48,16.75-2,1.36-3.94,2.71-5.92,4-3.64,2.42-7.12,4.44-11,6.52-2.11,1.11-4.18,2.23-6.25,3.39Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M488.78,119.3C485.39,115.78,455,85.47,466.34,82c8.25-2.54,32,23.7,37.15,30,14.85,18.76,27.08,42.71,36.28,64.78,6.92,16.6,6,27.7,6.51,45,.23,8.59-8.81,4-11.53-6.23-3.45-13-2.17-18.15-8.79-31.75C519.73,171,513.59,158,507.22,145.24a108,108,0,0,0-18.44-25.87Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M236.56,38.11c2.18,2.11,7.45,5.9,8.56,8.37,2.71,6-5.06,12.49-9.46,7.66-3-3.29-4.73-4.33-8.2-7-3.14-2.45-5.87-5.09-9.1-7.49-3.65-2.73,0-5.54,2.09-7.8,2.58-2.88,4.22-3.59,7.4-1.11,2.76,2.17,5.8,4.6,8.36,7l.35.34Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M312.72,77.43h0c-.34,4.16-2.91,6.8-7.23,6.27-5.42-.67-6.18-.79-11.65-.1-2.72.34-13.08.49-15.53-.29-7.44-2.38-5.05-11.76,5.6-12,4.44-.08,8.45-.41,12.84-.67a66,66,0,0,1,7.44,0c3.25.21,6.07.44,7.8,3.77a6.3,6.3,0,0,1,.73,3Z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M361.87,74.27c-1.4,1.48-9.85,9.71-11.14,10.48-5.64,3.36-13.48-3.37-6.53-10.43,2.9-3,6.33-6.11,9.45-8.82,2.29-2,7.14-7.55,9.22-8.71,7.61-3.87,13.55,4.36,4.4,12.54C365.27,71.13,363.79,72.33,361.87,74.27Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M222.79,91.51A6,6,0,0,1,220,86.27a6.83,6.83,0,0,1,7-6.61l.38,0c5.63.52,11.24,2.14,17.09,2.7,5.54.51,12,.41,8.64,8.11-2.94,6.78-5.24,5.63-11.6,4.11a37,37,0,0,0-6.62-1c-3.54-.19-9-.26-12.09-2.06Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M413.7,220.23c-7.08,3-12-8-3.68-11.7.21-.1.42-.2.65-.29,2.44-1,4.75-1.78,7.2-2.7,4.93-1.85,5.76-4.48,12.29-5.66,1.83-.32,4.25-.67,6.1-.86,7.12-.54,10.3,5.14,4,9.73-4.79,3.43-7.54,3.07-12.32,5.51a61.26,61.26,0,0,1-6.88,3.18c-2.48.92-4.92,1.77-7.36,2.79Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M513.15,302.55c-2.29,3.53-5.14,7.26-7.62,10.73-2.25,3.1-9.4,8.06-12.75,4.54-3.77-4,3.46-12.68,5.92-16.14,1.53-2.14,3.11-4.2,4.76-6.25,1.86-2.44,5.64-8.73,7.45-10.25,6.78-5.2,14.13,1.8,6.63,11.52C515.9,298.84,514.66,300.24,513.15,302.55Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M372,381.42c-7.22-2.66-3.3-14,5.32-11.06l.68.24c2.49,1,4.32,1.7,6.91,2.48a51.61,51.61,0,0,1,8.91,3.76c3.59,1.73,9.45.91,10.49,6.24s-6.73,6.42-10.49,6.37c-4.32-.07-6.17-2.79-10-4l-.57-.18a60.58,60.58,0,0,1-8.3-2.73c-1-.41-1.95-.8-2.94-1.16Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M346.3,484.68c-3.23,2.63-6.58,4.71-9.76,7.24-6,4.78-13.69-4.48-6.66-10.3.19-.15.36-.3.54-.46,3.11-2.39,5.62-4.11,8.88-6.26,4.22-3,7.83-6.71,11.86-9.58,7.72-5.5,13.46-.17,7.67,8.22-4.13,6-7.25,7-12.53,11.14Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M224,383.94c8.23,2.36,7,12.43-5.31,12.19-4.81-.17-6.93-1.35-12.11-.61-4.07.57-15.64.05-14-6.49.82-3.42,4.28-4.62,7.4-5,1.75-.18,3.47-.49,5.21-.79,5.69-1,8.59.67,14,.5a23.45,23.45,0,0,1,4.81.17Z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M79.21,381.21c-.5-7.69,11.47-8.7,12.26.38l.06.73c.19,3.86.14,7,0,10.83-.09,5.65,2.13,14.75-1.92,19.62-2.8,3.36-6.24,1.1-7.89-2.15-1.13-2.23-1.77-5.36-2.83-7.91l-.79-1.87c-2.91-7.3,1.36-10,1.25-15.95C79.35,383.66,79.28,382.43,79.21,381.21Z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M124.63,287.3c-3.53-2.88-6.63-6.15-10.06-9.18-6.15-5.43,1.71-14.12,9.58-7.67,2.91,2.41,5.9,5.32,8.6,8,2.21,2.13,8.07,6.55,9.38,8.52,4.44,7.3-3.31,13.85-12.17,5.35-1.94-1.86-3.21-3.25-5.33-5Z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M89.75,168.88c-.88,4.07-2.21,7.77-3.13,11.73-1.74,7.5-13.51,5-11.63-3.92l.15-.7c.94-3.81,1.83-6.71,3.06-10.43s2-10.62,4.36-13.51c4.72-5.9,12.06-3.56,10.51,5.33C92.42,161.06,90.67,165,89.75,168.88Z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M294.69,128.56c-4.14-.59-7.92-1.64-11.94-2.26-7.6-1.18-6-13.1,3.05-11.89l.71.1c3.87.66,6.83,1.33,10.62,2.28,4.54,1,10.38,1.13,14.34,3.59,2.92,1.81,8.5,6.34,6.11,10.21s-11.74.75-15.31-.24a61.8,61.8,0,0,0-7.58-1.79Z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M388.5,145.74c4.09,3.84,13.19,10.21,12.5,16.66-.55,5.2-6.7,4.21-9.9,2.32-2.33-1.38-5.18-4.84-7.59-6.8-1.32-1.07-2.75-2.09-4.11-3.13-3.28-2.5-6.15-5.32-9.42-7.91-6.36-5,1.89-15.1,9-9.19,3.1,2.59,6.67,5.31,9.55,8.05Z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M454.28,250.75c.42-3,.41-9.48,1.75-11.84,3.28-5.73,13.08-3.24,11.75,3.16-.9,4.37-.72,6.38-.82,10.74-.1,3.14-.33,5.82-.28,9,.07,4.3.4,11-4.65,12.77-4.55,1.58-7.41-3.25-8-7a71.19,71.19,0,0,1-.23-7.59,58.23,58.23,0,0,1,.49-9.24Z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M351.29,433.06c-8.85,3.13-15.43-4.87-3.37-12.53,4.06-2.6,7.92-5.38,12-8,3.72-2.34,8.7-7.08,13.2-7.19,7.41-.17,8.33,8.45,4.45,9.87s-9.86,7.54-13.94,10.3c-2.79,1.89-9.57,6.42-12.36,7.52Z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M175,463.64c2.18,2.1,7.44,5.9,8.56,8.36,2.71,6-5.06,12.51-9.46,7.67-3-3.3-4.74-4.33-8.2-7A92,92,0,0,1,155,462.41c-2.68-2.89-5-10.51-1.51-13.3,4.52-3.65,10.89,5.24,13.75,7.87,2.51,2.28,5.21,4.28,7.73,6.66Z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M129.34,341.29c1.23,6.5-7.83,11-11,5.26-3.58-6.39-3.82-6-8.91-10.51a20.11,20.11,0,0,1-5.71-9.09c-2.26-7.36,6.9-12.26,11.84-5.81,3.77,4.92,7.25,9.77,10.83,14.8a17.67,17.67,0,0,1,2.93,5.35Z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M77.54,211.11c5.24-1.26,14.43-5.13,17.9,1.31a5.65,5.65,0,0,1-2.14,7.7,5.73,5.73,0,0,1-1.66.62c-2.51.54-4.37.45-7.09,1.37C79.06,224,75.24,226,69.3,227.3c-2.63.56-4.53,1-6.72-1.19a6.71,6.71,0,0,1,3-11.35c3.92-1.17,8.12-2.69,12-3.65Z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M171.63,129.09c1-2.87,2.1-9.27,3.84-11.32,4.27-5,13.46-.85,11,5.2-1.66,4.14-1.85,6.15-2.74,10.42-.83,3.86-2,7.39-2.72,11.35-.81,4.21-3.23,13.06-8.82,12.78s-4.44-8.71-4.17-12.41a45.12,45.12,0,0,1,1.71-9c.57-2.38,1.16-4.69,1.9-7Z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M406.4,105.63a37.12,37.12,0,0,1,1.9,6.46v.2c.44,8.19-10.86,10.2-13.25.72-1-4.29-1.14-7.16-2.83-11.47-1.06-2.68-4.16-9.21-2.36-11.82,1.1-1.6,4.81-2.35,6.67-2.73,3.08-.62,4.69.2,5.63,3.2,1.59,5.13,2.5,10.34,4.22,15.44Z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M478.78,156.89a37,37,0,0,1,6.74-.29.67.67,0,0,0,.2,0c8,1.57,7.24,13-2.52,13-4.42,0-7.23-.63-11.82,0-6.58.85-13.28,1.69-19.9,1-3.91-.39-6.64-.95-8-5-2-5.82,9.82-7.49,13.45-8,5.25-.7,11.72-.55,17.1-.63,1.61,0,3.17-.08,4.77-.2Z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M437.54,298.55a5.93,5.93,0,0,1,1.54-5.76,6.84,6.84,0,0,1,9.66,0,3.45,3.45,0,0,1,.26.28c4.1,4.75,7.15,9.95,11.45,14.68,3,3.28,7.52,8,6.2,13s-6.55,4.27-10,1.88c-4.68-3.25-7.7-9.88-11.77-14.26-2.43-2.58-6.37-6.38-7.35-9.8Z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M446,398.36c-4.78,3-13.32,9.44-18.8,4.37-3.19-2.94-1.63-7.22,1.77-9.29,1.73-1,4.18-2.09,6.1-3.18,2.68-1.54,4.72-2.77,7.57-4.13,3.26-1.55,5.83-3.23,8.92-4.86,3.58-1.9,9.11-3.83,12.71-1s1.08,7.25-1.74,9.53c-4.4,3.53-11.52,5.55-16.53,8.61Z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M290.75,456.78c-2-1.94-4.63-4.66-2.33-7.53,1.53-1.91,6.06-3.75,8.48-3.33,3.3.57,5.77,5.43,7.89,8,.72.87,1.44,1.61,2.25,2.42,4,3.88,11.59,10.11,6.53,16.1-2.52,3-6.24,2.78-8.81-.06-3-3.29-5.93-6.24-8.75-9.72a73,73,0,0,0-5.26-5.86Z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M222.46,459.65a35,35,0,0,1-6.38,2.15h-.2c-8.17.76-10.63-10.45-1.26-13.21,4.25-1.21,7.12-1.43,11.37-3.29,4.94-2.18,15.18-7.17,19.07-.91,2.65,4.3-1.49,8.33-5.45,9.78-5.64,2.07-11.54,3.3-17.15,5.44Z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M143.48,396.46a35.5,35.5,0,0,1-1.32,6.61l-.08.18c-3.4,7.46-14.34,4-12.06-5.51,1.28-4.92,2.47-7.53,2.92-12.84.35-4.2.7-13.2,3.73-16.12,3.41-3.27,7.48-.52,9.2,3.18a12.73,12.73,0,0,1,1,8.28c-1,5.48-2.56,10.83-3.42,16.22Z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M61.62,337.67a38.69,38.69,0,0,1-6.7-.73l-.2-.06c-7.72-2.73-5.24-13.95,4.43-12.51,4.93.81,7.83,1.7,13.09,1.79s12.46.3,15.85,5.37c3.51,5.25-1.31,8.29-6.32,8.51-4,.17-11.24-1.34-15.48-1.89l-1-.13c-1.25-.15-2.46-.27-3.71-.35Z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M136.41,209a6,6,0,0,1-3.5,4.84,6.84,6.84,0,0,1-9-3.52,3.45,3.45,0,0,1-.14-.34c-2-5.29-2.94-11-5-16.58-1.63-4.38-4-9.81-.5-14,3.3-4,7.85-1.79,10,2.23s2.59,10.33,4.49,15.06c.06.19.15.38.22.56,1.36,3.27,3.66,8.24,3.36,11.78Z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M138,103.24a6,6,0,0,1-5.39-2.55,6.84,6.84,0,0,1,1.77-9.51l.28-.18c5.27-3.11,11.13-5.43,16.57-8.49,3.59-2,7.71-4.92,11.56-1.41,3.69,3.38,2.28,8.72-2,11.12-3,1.66-6.67,2.57-9.92,4.38-.68.38-1.29.76-1.93,1.16-3,2-7.43,5.13-11,5.5Z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M423,113.76a58.86,58.86,0,0,1-2.93-8.27c-2.14-8.22,9.18-12.28,12-3.74,1.78,5.14,4,10,5.71,15.22,1.65,5,4.75,12.45-.55,16.4-4.41,3.29-8.4-1.62-9.79-5.58-1.19-3.37-1.47-6.91-2.72-10.24-.51-1.27-1.11-2.55-1.71-3.79Z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M501.29,207h0c2.3,3.49,1.93,7.14-1.78,9.41-5.07,3.11-5.3,3.08-9.44,7.43-1.64,1.67-5.63,5.32-7.88,5.8-4.36.91-12.33-5.33-6.19-10.32,5-4.08,9-8.53,14.39-12.34,2.68-1.86,5-3.41,8.46-1.88A6.23,6.23,0,0,1,501.29,207Z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M406.08,312.24h0c3.54-2.22,7.18-1.76,9.37,2,3,5.15,3,5.37,7.21,9.63,1.89,1.93,3.3,3.62,5.37,5.49,2.6,2.35,6.13,5.6,4,9.47-2.39,4.23-8.84,3.53-12.26.52-1.85-1.65-4.62-4.83-6.35-6.78a85.85,85.85,0,0,1-7.57-9.43c-1.82-2.72-3.32-5.12-1.7-8.5a6.54,6.54,0,0,1,2-2.4Z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M442.5,427.14c2.43,3.51.22,7.06-4.11,7.22-1.89.05-5.17-.27-7.12-.44-3.49-.29-6.46-1.12-10-1.27s-11.29-.53-14-2.39c-5.08-3.46-3.37-12.31,4.21-11.29,8.07,1.08,25.74,1,30.78,7.82l.25.35Z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M264,481.7h0c2.35,3.46,2,7.12-1.67,9.43-5,3.17-5.26,3.16-9.36,7.54a56.47,56.47,0,0,1-6.58,5.78c-6.85,5-14.81-4-7.91-9.75,5.13-4.34,9.08-8.92,14.62-12.88,2.66-1.91,5-3.49,8.44-2A6.59,6.59,0,0,1,264,481.7Z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M244.73,403.88h0c3.07-2.84,6.73-3.05,9.57.23,3.89,4.52,3.9,4.75,8.85,8.15a58.13,58.13,0,0,1,6.7,5.64c6,6-1.73,15.24-8.47,9.28-5.06-4.44-10.18-7.66-14.91-12.54-2.27-2.33-4.19-4.42-3.24-8a6.34,6.34,0,0,1,1.5-2.72Z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M123.45,418.7h0c3.66,2,5,5.41,2.81,9.16-3,5.12-3.24,5.21-4.87,11-.69,2.35-2.47,7.83-4.59,9.1s-6.52.34-8.52-.51c-4.16-1.75-1.5-5.67-.42-8.5,2-5.25,3.34-10,5.93-15.14,1.51-2.91,2.87-5.39,6.6-5.62a6.55,6.55,0,0,1,3.06.53Z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M67.12,290.16h0c1.5,3.89.36,7.39-3.76,8.8-5.63,2-5.85,1.88-10.82,5.22-2.38,1.57-9.58,5.05-12.54,5.17-6.64.29-8.67-8.41-1-12.24,6-3,11.33-6.73,17.48-9.31,3-1.25,5.67-2.27,8.67,0a6.43,6.43,0,0,1,2,2.39Z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M160.64,363.79a42.38,42.38,0,0,1-9.91-2.5c-8.64-3.36-5.55-14.15,3.91-11.72,7.59,1.95,18,2.5,24.68,6.28a15.12,15.12,0,0,1,2.58,1.84c6.19,5.77,2.5,12.47-5.05,10.1-4.83-1.5-9.11-3.17-14.17-3.77l-2-.23Z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M124.62,151.72a56.63,56.63,0,0,1-6.25-6.14c-5.53-6.45,2.87-15.05,9.14-8.61,4.36,4.42,16.27,13.94,17.48,19.56,1.51,7.17-6,10.82-11.63,4.3-2.66-3.11-3.86-5.1-7.15-7.82Z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M235.35,36.45c2.19,2.1,7.44,5.89,8.56,8.36,2.7,6-5,12.49-9.46,7.66-3-3.29-4.74-4.33-8.2-7-3.16-2.46-5.88-5.1-9.09-7.49-3.68-2.74,0-5.55,2.06-7.81,2.59-2.86,4.23-3.59,7.41-1.1,2.76,2.16,5.8,4.59,8.36,7l.36.35Z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M311.51,75.76h0c-.35,4.16-2.93,6.8-7.24,6.27-5.42-.66-6.18-.79-11.65-.1-2.73.35-13.08.49-15.53-.29-7.43-2.38-5-11.75,5.61-12,4.45-.09,8.45-.42,12.84-.67A61.88,61.88,0,0,1,303,69c3.27.2,6.08.45,7.81,3.77a6.26,6.26,0,0,1,.74,3Z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M360.66,72.61c-1.41,1.47-9.86,9.71-11.15,10.47C343.88,86.44,336,79.72,343,72.65c2.89-3,6.32-6.11,9.44-8.81,2.28-2.06,7.15-7.56,9.21-8.72,7.62-3.86,13.56,4.36,4.41,12.56-2,1.79-3.49,2.93-5.39,4.93Z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "k",
  d: "M221.58,89.85a6,6,0,0,1-2.85-5.25A6.84,6.84,0,0,1,225.78,78l.37,0c5.64.52,11.25,2.14,17.11,2.7,5.53.51,12,.41,8.62,8.11-2.94,6.79-5.25,5.63-11.6,4.12a37,37,0,0,0-6.62-1c-3.54-.19-9-.26-12.08-2.05Z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M412.49,218.56c-7.09,3-12-7.95-3.7-11.7l.66-.29c2.44-1,4.76-1.78,7.2-2.69,4.94-1.86,5.75-4.49,12.29-5.67,1.83-.31,4.24-.67,6.11-.86,7.12-.54,10.29,5.14,4,9.74-4.79,3.42-7.53,3.06-12.34,5.5a57.77,57.77,0,0,1-6.87,3.18C417.37,216.69,414.92,217.54,412.49,218.56Z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M511.93,300.88c-2.3,3.53-5.13,7.28-7.63,10.73-2.24,3.1-9.38,8.07-12.74,4.55-3.77-4,3.46-12.68,5.93-16.15,1.52-2.14,3.11-4.19,4.74-6.24,1.88-2.43,5.64-8.74,7.46-10.26,6.78-5.2,14.13,1.8,6.63,11.52-1.64,2.14-2.88,3.54-4.39,5.85Z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M370.76,379.75c-7.23-2.66-3.3-14,5.32-11.06l.69.24a70.88,70.88,0,0,0,6.91,2.48,53.33,53.33,0,0,1,8.92,3.76c3.57,1.73,9.43.91,10.47,6.24s-6.73,6.42-10.48,6.37c-4.33-.07-6.17-2.79-10-4l-.57-.18a60.58,60.58,0,0,1-8.3-2.73c-1-.41-1.94-.8-2.94-1.16Z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M345.07,483c-3.23,2.63-6.55,4.71-9.75,7.25-6,4.78-13.67-4.48-6.67-10.31.19-.14.37-.3.56-.46,3.11-2.39,5.6-4.11,8.88-6.26,4.21-3,7.82-6.71,11.85-9.58,7.72-5.49,13.46-.17,7.68,8.22-4.15,6-7.26,7-12.55,11.14Z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M222.75,382.28c8.22,2.35,7,12.42-5.31,12.18-4.82-.17-6.93-1.35-12.12-.61-4.06.57-15.63,0-14-6.49.83-3.42,4.29-4.62,7.4-5,1.76-.19,3.49-.5,5.23-.8,5.69-1,8.58.68,14,.51a22.21,22.21,0,0,1,4.82.17Z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M78,379.54c-.49-7.69,11.48-8.69,12.28.39v.72c.19,3.87.14,7,0,10.84-.11,5.64,2.13,14.74-1.94,19.62-2.77,3.35-6.22,1.1-7.88-2.16-1.12-2.23-1.77-5.36-2.83-7.9-.27-.62-.53-1.25-.79-1.88-2.92-7.3,1.36-10.05,1.26-15.95,0-1.23-.07-2.45-.16-3.68Z"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M123.41,285.64c-3.53-2.89-6.62-6.16-10.06-9.19-6.16-5.43,1.73-14.12,9.57-7.66,2.91,2.4,5.91,5.32,8.61,8,2.22,2.12,8.07,6.54,9.39,8.51,4.43,7.3-3.32,13.85-12.17,5.35-2-1.86-3.21-3.24-5.34-5Z"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M88.54,167.21c-.9,4.08-2.22,7.78-3.14,11.74-1.74,7.49-13.5,5-11.62-3.93a3.62,3.62,0,0,1,.14-.7c.94-3.81,1.83-6.7,3.06-10.42s2-10.63,4.36-13.52c4.73-5.9,12.06-3.56,10.51,5.33-.65,3.69-2.4,7.67-3.31,11.5Z"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M293.47,126.89c-4.13-.59-7.92-1.63-11.93-2.26-7.61-1.17-6-13.09,3-11.89l.71.11c3.87.65,6.82,1.33,10.62,2.28,4.55,1,10.38,1.13,14.34,3.58,2.93,1.8,8.5,6.34,6.12,10.21s-11.74.76-15.31-.24a63.85,63.85,0,0,0-7.59-1.79Z"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M387.29,144.07c4.08,3.84,13.17,10.21,12.5,16.67-.55,5.19-6.71,4.2-9.91,2.31-2.33-1.38-5.18-4.84-7.59-6.79-1.32-1.08-2.75-2.09-4.11-3.13-3.28-2.51-6.15-5.32-9.41-7.91-6.36-5,1.88-15.1,9-9.2,3.1,2.59,6.66,5.3,9.55,8Z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M453.06,249.08c.43-3,.4-9.48,1.75-11.83,3.29-5.73,13.09-3.25,11.76,3.16-.9,4.36-.72,6.37-.83,10.73-.1,3.14-.34,5.82-.29,9,.07,4.3.41,11-4.64,12.77-4.55,1.58-7.41-3.24-8-7a66.29,66.29,0,0,1-.23-7.59A54.88,54.88,0,0,1,453.06,249.08Z"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M350.08,431.4c-8.85,3.12-15.44-4.88-3.38-12.53,4.06-2.6,7.92-5.39,12-8,3.73-2.35,8.68-7.08,13.19-7.2,7.41-.17,8.33,8.45,4.45,9.88s-9.87,7.54-13.92,10.29c-2.8,1.89-9.58,6.43-12.37,7.53Z"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M173.8,462c2.17,2.11,7.45,5.9,8.54,8.36,2.71,6-5,12.51-9.44,7.67-3-3.29-4.75-4.33-8.21-7a91.1,91.1,0,0,1-10.86-10.29c-2.68-2.87-5-10.51-1.53-13.3,4.53-3.65,10.9,5.24,13.76,7.87,2.51,2.29,5.2,4.28,7.74,6.66Z"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M129.85,339.06c1.22,6.49-7.83,11-11,5.24-3.58-6.37-3.83-5.95-8.9-10.51a20.07,20.07,0,0,1-5.73-9.08c-2.25-7.35,6.89-12.25,11.85-5.81,3.77,4.91,7.24,9.77,10.83,14.81a17,17,0,0,1,2.93,5.35Z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M76.33,209.45c5.22-1.27,14.42-5.14,17.89,1.31a5.64,5.64,0,0,1-2.13,7.69,5.79,5.79,0,0,1-1.67.62c-2.51.56-4.36.45-7.09,1.38-5.5,1.89-9.31,3.9-15.24,5.19-2.64.56-4.54,1-6.73-1.19a6.72,6.72,0,0,1,3-11.36c3.9-1.17,8.12-2.69,12-3.64Z"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M170.41,127.42c1-2.87,2.1-9.26,3.85-11.32,4.26-5,13.45-.85,11,5.21-1.67,4.13-1.86,6.15-2.75,10.41-.82,3.87-2,7.4-2.71,11.35-.83,4.21-3.24,13.06-8.83,12.79s-4.44-8.72-4.17-12.41a47.5,47.5,0,0,1,1.71-9c.57-2.37,1.16-4.69,1.9-7Z"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M405.18,104a34.34,34.34,0,0,1,1.89,6.45.74.74,0,0,1,0,.21c.45,8.18-10.85,10.19-13.23.71-1-4.28-1.15-7.16-2.84-11.47-1.06-2.68-4.16-9.21-2.36-11.81,1.1-1.61,4.82-2.36,6.68-2.74,3.07-.62,4.69.2,5.62,3.21,1.59,5.12,2.5,10.34,4.22,15.44Z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M477.57,155.22a36,36,0,0,1,6.72-.27h.21c8,1.55,7.26,13-2.51,13-4.42,0-7.24-.62-11.83,0-6.58.85-13.27,1.69-19.91,1-3.9-.39-6.63-1-8-5-2-5.83,9.82-7.5,13.44-8,5.24-.69,11.73-.55,17.1-.62,1.62,0,3.17-.08,4.78-.21Z"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M436.32,296.88a6,6,0,0,1,1.53-5.76,6.84,6.84,0,0,1,9.66,0,3.45,3.45,0,0,1,.26.28c4.12,4.75,7.16,9.95,11.46,14.68,3,3.28,7.52,8,6.2,12.95s-6.54,4.28-10,1.88c-4.7-3.25-7.71-9.88-11.78-14.26-2.44-2.58-6.37-6.38-7.36-9.8Z"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  className: "k",
  d: "M444.77,396.7c-4.76,3-13.32,9.42-18.8,4.36-3.2-2.93-1.63-7.22,1.76-9.29,1.73-1,4.2-2.08,6.11-3.17,2.68-1.54,4.71-2.78,7.58-4.14,3.24-1.55,5.83-3.22,8.92-4.86,3.57-1.89,9.11-3.83,12.71-1s1.08,7.24-1.75,9.52c-4.4,3.54-11.52,5.56-16.53,8.62Z"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M289.53,455.11c-2-1.94-4.61-4.66-2.32-7.53,1.52-1.91,6.06-3.74,8.47-3.33,3.29.57,5.77,5.43,7.9,8a31.93,31.93,0,0,0,2.24,2.42c4,3.87,11.59,10.11,6.53,16.12-2.51,3-6.23,2.75-8.8-.07-3-3.3-5.93-6.25-8.75-9.72a73.3,73.3,0,0,0-5.27-5.87Z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  className: "k",
  d: "M221.24,458a36.93,36.93,0,0,1-6.39,2.15.61.61,0,0,1-.19,0c-8.15.77-10.63-10.45-1.25-13.21,4.25-1.21,7.11-1.43,11.35-3.28,5-2.18,15.19-7.18,19.08-.91,2.66,4.29-1.49,8.32-5.44,9.77-5.65,2.07-11.55,3.3-17.16,5.45Z"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M142.27,394.79A36.23,36.23,0,0,1,141,401.4a1.08,1.08,0,0,0-.08.19c-3.4,7.45-14.35,4-12.07-5.52,1.28-4.92,2.48-7.53,2.93-12.84.34-4.19.69-13.19,3.72-16.11,3.41-3.28,7.48-.52,9.21,3.17a12.69,12.69,0,0,1,1,8.29c-1,5.47-2.56,10.82-3.41,16.21Z"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M62.68,336.61a37.74,37.74,0,0,1-6.7-.73.66.66,0,0,0-.2-.06c-7.72-2.73-5.24-13.94,4.43-12.51,4.93.82,7.84,1.71,13.09,1.8,5.41.08,12.46.29,15.86,5.36,3.51,5.24-1.32,8.29-6.33,8.51-4,.17-11.24-1.34-15.48-1.9l-1-.11c-1.24-.17-2.45-.28-3.71-.36Z"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M135.19,207.32a6,6,0,0,1-3.5,4.84,6.85,6.85,0,0,1-9-3.54,3.05,3.05,0,0,1-.13-.32c-2-5.29-2.93-11.05-5-16.57-1.63-4.39-4-9.81-.49-14,3.29-4,7.84-1.8,10,2.22s2.58,10.32,4.49,15.06c.07.19.15.38.22.56,1.35,3.28,3.65,8.24,3.36,11.78Z"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M136.74,101.57A6,6,0,0,1,131.35,99a6.85,6.85,0,0,1,1.79-9.51,3.28,3.28,0,0,1,.31-.2c5.26-3.11,11.13-5.42,16.56-8.49,3.6-2,7.72-4.92,11.56-1.41,3.69,3.39,2.28,8.73-2,11.12-3,1.66-6.67,2.57-9.93,4.38-.67.38-1.29.76-1.94,1.17-3,1.94-7.41,5.12-11,5.49Z"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M421.75,112.09a56.47,56.47,0,0,1-2.94-8.27c-2.13-8.22,9.19-12.28,12-3.74,1.77,5.14,4,10,5.71,15.23,1.66,5,4.76,12.44-.55,16.39-4.41,3.3-8.39-1.61-9.79-5.56-1.19-3.39-1.47-6.93-2.71-10.25-.51-1.27-1.12-2.55-1.71-3.8Z"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M500.08,205.35h0c2.3,3.49,1.93,7.15-1.79,9.42-5.07,3.11-5.3,3.08-9.44,7.42-1.63,1.67-5.62,5.32-7.88,5.81-4.35.91-12.34-5.33-6.19-10.33,5-4.08,9-8.53,14.39-12.34,2.69-1.86,5-3.41,8.46-1.88a6.43,6.43,0,0,1,2.45,1.9Z"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M404.86,310.57h0c3.54-2.22,7.2-1.75,9.37,2,3,5.14,3,5.37,7.21,9.62,1.9,1.94,3.29,3.62,5.37,5.5,2.6,2.34,6.13,5.59,4,9.46-2.38,4.24-8.84,3.54-12.26.52-1.85-1.64-4.62-4.83-6.35-6.78a88,88,0,0,1-7.58-9.42c-1.8-2.73-3.3-5.13-1.69-8.51a6.64,6.64,0,0,1,2-2.4Z"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M441.29,425.47c2.42,3.51.21,7.07-4.12,7.22-1.88.05-5.16-.27-7.11-.44-3.5-.29-6.46-1.12-10-1.26s-11.3-.53-14-2.38c-5.07-3.47-3.37-12.33,4.21-11.31,8.07,1.08,25.75,1,30.79,7.83.08.12.16.23.25.34Z"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M262.77,480h0c2.34,3.45,2,7.12-1.68,9.43-5,3.16-5.26,3.15-9.35,7.53a59.26,59.26,0,0,1-6.58,5.79c-6.86,5-14.82-4-7.92-9.76,5.14-4.34,9.08-8.92,14.62-12.88,2.66-1.9,5-3.48,8.43-2A6.76,6.76,0,0,1,262.77,480Z"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M243.51,402.21h0c3.07-2.83,6.74-3,9.58.24,3.87,4.52,3.9,4.74,8.85,8.14a58.13,58.13,0,0,1,6.7,5.64c6,6-1.74,15.24-8.47,9.29-5.06-4.43-10.18-7.67-14.93-12.55-2.27-2.33-4.18-4.42-3.22-8a6.43,6.43,0,0,1,1.49-2.72Z"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M122.23,417h0c3.66,2,5,5.42,2.83,9.16-3,5.13-3.26,5.21-4.89,11-.68,2.34-2.48,7.82-4.59,9.09s-6.51.34-8.53-.51c-4.14-1.75-1.48-5.66-.42-8.5,2-5.25,3.36-10,5.94-15.14,1.51-2.91,2.87-5.38,6.6-5.62a6.55,6.55,0,0,1,3.06.53Z"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M65.9,288.49h0c1.51,3.89.36,7.39-3.76,8.81-5.63,1.94-5.84,1.87-10.83,5.21-2.38,1.58-9.56,5.05-12.54,5.18-6.63.28-8.66-8.41-1-12.25,6-3,11.31-6.72,17.46-9.31,3-1.25,5.67-2.25,8.67,0a6.34,6.34,0,0,1,2,2.39Z"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M159.42,362.12a42.33,42.33,0,0,1-9.92-2.5c-8.63-3.36-5.54-14.15,3.93-11.72,7.59,2,18,2.5,24.67,6.28a14.28,14.28,0,0,1,2.58,1.85c6.2,5.77,2.51,12.46-5.05,10.09-4.84-1.5-9.12-3.17-14.18-3.77l-2-.23Z"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M123.41,150.05a56.7,56.7,0,0,1-6.26-6.14c-5.53-6.45,2.87-15,9.13-8.61,4.37,4.42,16.28,13.94,17.48,19.56,1.53,7.18-6,10.82-11.61,4.3-2.67-3.11-3.86-5.09-7.15-7.81C124.47,150.92,123.93,150.49,123.41,150.05Z"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  className: "m",
  d: "M49.13,147.8l74.29-9.12c36.94-4.54,77.41-3.13,108.94,19.73,25,18.08,39.2,46.26,43.88,84.38,7,57-10,90.6-30.85,112.71C209.7,393,162.29,400,135.56,403.3L49.09,413.92Zm66.44,50.49-.07,148.82,20-2.46c34.2-4.2,50.59-20.17,56.5-27.28,12.9-15.15,19.24-38.27,16.19-63-2.84-23.19-12.48-40-25.18-49.18-15.75-11.23-34.85-10.88-49.4-9.09Z"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  className: "m",
  d: "M463.83,259.66l73.81,94.27-77,9.46-72.54-96.82.22,105.7-66.43,8.15,0-266.11,85.29-10.48c35.77-4.39,58.65,0,75.51,13.87,14.22,11.82,24.34,32.52,27.24,56.1s-1.77,44.11-14.08,60.78C487.68,246,481.13,251.15,463.83,259.66Zm-75.72-100v68.22l11.79-1.45c31.84-3.9,44.93-17.48,41.89-42.24-2.8-22.8-13.2-29.5-41.1-26.08Z"
});

var SvgDrLogo = function SvgDrLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 563 563",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DRLogo.05619df5.svg";
export { ForwardRef as ReactComponent };